import { PaperConfig } from './types';

/**
 * English Literature Paper 2 (1ET0/02)
 * - Section A: 19th-Century Novel (extract + whole text essay)
 * - Section B: Poetry Anthology (named poem + comparison)
 */
export const englishLiteraturePaper2Config: PaperConfig = {
  paperCode: '1ET0/02',
  displayName: 'English Literature Paper 2',
  subject: 'English Literature',
  paperNumber: 'Paper 2',
  totalTimeMinutes: 135, // 2 hours 15 minutes

  sections: [
    {
      id: 'A',
      title: 'SECTION A',
      subtitle: '19th-Century Novel',
      instructions: [
        'Answer BOTH questions in this section on your studied novel.',
        'You should spend about 55 minutes on this section.',
        'Write your answers in the spaces provided.',
      ],
      // SectionA_A = Extract analysis (Q1a), SectionA_B = Whole text essay (Q1b)
      categories: ['SectionA_A', 'SectionA_B'],
      timeGuidance: 55,
    },
    {
      id: 'B',
      title: 'SECTION B',
      subtitle: 'Poetry Anthology',
      instructions: [
        'Answer BOTH questions in this section.',
        'You should spend about 1 hour 20 minutes on this section.',
        'Write your answers in the spaces provided.',
      ],
      // SectionB_Q2 = Named poem analysis, SectionB_Q3 = Poetry comparison
      categories: ['SectionB_Q2', 'SectionB_Q3'],
      timeGuidance: 80,
    },
  ],

  // Literature papers typically don't have a reading insert
  // The extract/poems are embedded in the questions
};
